import * as React from 'react';

import {
  DrawerContext,
  IconRegularClose,
  ReactFCC,
} from '@notino/react-styleguide';
import { IIconProps } from '@notino/react-styleguide/dist/types/components/atoms/Icons/utils/model';

import {
  DrawerTitleContainer,
  DrawerIconWrapper,
  DrawerDragger,
  StyledDrawerTitle,
  DrawerTitleWrapper,
  CloseIconButton,
} from './styled';

export interface IDrawerTitleProps {
  name: React.ReactNode;
  titleIcon?: ReactFCC<IIconProps>;
}

export const DrawerTitle = ({
  name,
  titleIcon: CloseIconElement = IconRegularClose,
}: IDrawerTitleProps) => {
  const { closeDrawer } = DrawerContext.useDrawerContext();

  return (
    <DrawerTitleContainer>
      <DrawerIconWrapper>
        <DrawerDragger />
      </DrawerIconWrapper>
      <DrawerTitleWrapper>
        <StyledDrawerTitle>{name}</StyledDrawerTitle>

        <CloseIconButton
          onClick={() => {
            closeDrawer();
          }}
        >
          <CloseIconElement
            color="icon.primary"
            width="1.25rem"
            height="1.25rem"
          />
        </CloseIconButton>
      </DrawerTitleWrapper>
    </DrawerTitleContainer>
  );
};
